import {FormattedMessage} from 'react-intl';
import Messages from './Title.messages';

export default ({advertiser, category}) => {
    if (advertiser) {
        return <FormattedMessage {...Messages.advertiser} values={{advertiser: <strong>{advertiser.name}</strong>}}/>;
    } else if (category) {
        return <FormattedMessage {...Messages.category} values={{category: <strong>{category.name}</strong>}}/>;
    }

    return <FormattedMessage {...Messages.default}/>;
};
